import { authService } from '../../services/auth/auth.service.js';
import { userService } from '../../services/user/user.service.js';
import router from '../../router/index'
import { safeNavigate } from '../../router/navigation-guard'
import authStorageService from '../../services/auth/auth-storage.service.js';

const user = authStorageService.getUser();
export const state = user
    ? { status: { loggeduser: true }, user }
    : { status: {}, user: null };

export const actions = {
    login({ dispatch, commit }, { email, password, organizationName }) {
        commit('loginRequest', { email });
        return authService.login(email, password, organizationName)
            .then(
                result => { 
                    if (result.status == "SUCCESS") {
                        //alert(result.body.user.userType)
                        if (result.body.user.userType.trim() == "staff") {
                            // Use the new auth storage service to set all auth data
                            authStorageService.setAuthData({
                                token: result.body.user.token,
                                user: result.body.user,
                                businessConditions: result.body.businessConditions,
                                staffProfile: result.body.staffProfile,
                                roles: result.body.roles,
                                organisation: result.body.organisation
                            });

                            const businessConditions = {};
                            // result?.body?.organisation?.services?.forEach(service => {
                            //     businessConditions[service.serviceType] = service;
                            // });
                            // Loop through each service in the result
                            result?.body?.organisation?.services?.forEach(service => {
                                // Create a new object to store the service and its serviceProviders by name
                                const serviceObj = {
                                    id: service.id,
                                    serviceProviders: []
                                };

                                // Loop through each serviceProvider and use the provider's name as the key
                                service.serviceProviders?.forEach(provider => {
                                    serviceObj.serviceProviders.push(provider);
                                    // serviceObj.serviceProviders[provider.name] = provider;
                                });

                                // Store the service object under the serviceType key
                                businessConditions[service.serviceType] = serviceObj;
                            });
                            authStorageService.setBusinessConditions(businessConditions);

                            commit('loginSuccess', result.message);
                            
                            // Navigate based on user type using safe navigation with slight delay
                            setTimeout(() => {
                                const userType = result.body.user.userType.trim();
                                switch (userType) {
                                    case "branchStaff": 
                                        safeNavigate(router, '/teller-dashboard'); 
                                        break;
                                    case "branchAdmin": 
                                    case "hqStaff": 
                                    case "superAdminDefault":
                                    default:
                                        safeNavigate(router, '/'); 
                                        break;
                                }
                            }, 100);
                            return true;
                        } else {
                            commit('loginFailure', 'You are not authorised to access this platform');
                            dispatch('notification/error', 'You are not authorised to access this platform', { root: true });
                            return false;
                        }
                    } else {
                        commit('loginFailure', result.message || 'Login failed');
                        dispatch('notification/error', result.message || 'Login failed', { root: true });
                        return false;
                    }


                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    // register the user
    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        return userService.register(user)
            .then(
                response => {
                    if (response.status == "SUCCESS") {
                        commit('registerSuccess', response.body);
                        dispatch('notification/success', response.message, { root: true });
                        return response;
                    } else {
                        commit('registerFailure', response.message);
                        dispatch('notification/error', response.message, { root: true });
                        return response;
                    }
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    // Logout the user
    async logout({ commit }) {
        // Clear session storage and httpOnly cookie
        await authStorageService.clearAuthDataAsync();
        commit('logout');
    }
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    }
};

